export const getStockLabelKey = (stock: number, quantity: number) => {
  const stockState = (stock === 0 && 'out-of-stock') || (stock > 0 && stock < quantity && 'insufficient') || 'sufficient';

  const stockLabel = {
    'out-of-stock': 'common.outOfStock',
    insufficient: 'common.limitedStock',
    sufficient: 'common.inStock',
  }[stockState];

  return stockLabel;
};

export default getStockLabelKey;
